import { makeActionCreator } from '../../../core/types/redux';
import {
  MainActionConstants as C,
  OpenMessageBoxArgs,
  NavigateArgs,
  RequestUpdateProfileArgs,
  SetUpdatedProfileArgs,
  UpdateProfileFieldArgs,
  OpenSettingPopupArgs,
  RequestUpdatePasswordArgs,
  OpenSnackBarArgs,
} from './types';

const create = makeActionCreator<C>();

export const openMessageBox = create<OpenMessageBoxArgs>(C.MESSAGE_BOX_OPEN);
export const closeMessageBox = create(C.MESSAGE_BOX_CLOSE);
export const openSnackBar = create<OpenSnackBarArgs>(C.SNACK_BAR_OPEN);
export const closeSnackBar = create(C.SNACK_BAR_CLOSE);
export const navigate = create<NavigateArgs>(C.NAVIGATE);
export const openSettingsPopup = create<OpenSettingPopupArgs>(C.SETTINGS_POPUP_OPEN);
export const closeSettingsPopup = create(C.SETTINGS_POPUP_CLOSE);
export const updateProfileField = create<UpdateProfileFieldArgs>(C.PROFILE_FIELD_UPDATE);
export const requestUpdateProfile = create<RequestUpdateProfileArgs>(C.PROFILE_UPDATE);
export const setUpdatedProfile = create<SetUpdatedProfileArgs>(C.PROFILE_UPDATED_SET);
export const requestUpdatePassword = create<RequestUpdatePasswordArgs>(C.PASSWORD_UPDATE);
export const setUpdatedPassword = create<SetUpdatedProfileArgs>(C.PASSWORD_UPDATED_SET);
